import { Route } from '../../../shared/router';
import {AssemblyPage} from "../pages";

export const routes: Route[] = [
  {
    name: 'assembly',
    title: 'Assembly',
    path: '/assembly/:sessionId',
    component: AssemblyPage,
    layoutType: 'publicMain',
    isPublic: true,
    onlyNonAuth: false,
    availableFor: 'consumer',
  }
];
